// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import classNames from 'classnames'
import { Tooltip, SvgIcon } from 'ui_kit_qmd'
import moment from 'moment/moment'
import { getVisitsConfig } from './VisitConstants' // Import the utility function
import inactiveFilterIcon from '../../images/common/FilterInactive.png'
import activeFilterIcon from '../../images/common/activeFilter.png'
import { getServiceTypes } from '../../store/management/ManagementThunk'
import VisitsTableFiltersWrapper from './visits-table-title-filter-layout/VisitsTableFiltersWrapper'
import { visitTableTitles } from '../../utils/constants'
import { getVisitSearchParams } from './VisitTools'
import { DATE_ONLY_FORMAT } from '../../utils/dateUtils'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const formatDate = (date) => moment(date.substring(0, 10)).format(DATE_ONLY_FORMAT)

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const isWithFilterColumnTitle = (title) =>
  title === visitTableTitles.VISIT || title === visitTableTitles.STATUS || title === visitTableTitles.TAGS

export const VisitsTableHeader = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    visitsMode,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setVisitTypesFilterRow,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setStatusFilterRow,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    closeRemarks,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    visitTypesFilterRow,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    statusFilterRow,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    stateFilter,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    dispatchFilter,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isNeedToUpdateFilterIcon,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setStatusTagRow,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    tagFilterRow,
  }) => {
    const dispatch = useDispatch()
    const {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      initialStatusFilter,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      initialVisitTypes,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      initialTagsFilter,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      activeFlags,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      initialDrugScreenStatuses,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      initialIdentityVerificationStatuses,
    } = getVisitSearchParams()
    const [visitsListToShow, setVisitsListToShow] = useState(() => getVisitsConfig(visitsMode))
    const [isFilterOpen, setFilterOpen] = useState(false)
    const [isFirstTimeVisitTypeFilterOpenClick, setIsFirstTimeVisitTypeFilterOpenClick] = useState(true)
    const gridTemplateColumns = visitsListToShow.map((item) => item.width || '1fr').join(' ')
    const visitsHeaderStyles = { gridTemplateColumns }
    const changeFilterIconsState = () => {
      setVisitsListToShow((prev) =>
        prev.map((visitObj) => {
          switch (visitObj.title) {
            case visitTableTitles.STATUS:
              return { ...visitObj, isFilterActive: !!initialStatusFilter }
            case visitTableTitles.VISIT:
              return { ...visitObj, isFilterActive: !!initialVisitTypes }
            case visitTableTitles.TAGS:
              return {
                ...visitObj,
                isFilterActive:
                  !!initialTagsFilter ||
                  !!activeFlags?.length ||
                  !!initialDrugScreenStatuses ||
                  !!initialIdentityVerificationStatuses,
              }
            default:
              return visitObj
          }
        }),
      )
    }

    useEffect(() => {
      setVisitsListToShow(getVisitsConfig(visitsMode))
      changeFilterIconsState()
    }, [visitsMode])

    useEffect(() => {
      if (isNeedToUpdateFilterIcon) {
        changeFilterIconsState()
      }
    }, [isNeedToUpdateFilterIcon])

    const onOpenShowFilterSettings = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (titleName) => {
        if (isFirstTimeVisitTypeFilterOpenClick && titleName === visitTableTitles.VISIT) {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          dispatch(getServiceTypes())
          setIsFirstTimeVisitTypeFilterOpenClick(false)
        }
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setVisitsListToShow((prev) =>
          prev.map((visitObj) =>
            visitObj.title === titleName ?
              { ...visitObj, isShowFilterComponent: true }
            : { ...visitObj, isShowFilterComponent: false },
          ),
        )
      },
      [dispatch, isFirstTimeVisitTypeFilterOpenClick],
    )

    const showFilter = () => {
      console.log('rly')
      setFilterOpen(!isFilterOpen)
    }

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const closeFilter = (event) => {
      if (event?.target?.classList) {
        const classList = event?.target?.classList
        const isIcon = classList.contains('svg-component-icon') || classList.contains('svg-component-path')

        if (!isIcon) {
          setFilterOpen(false)
        }
      } else {
        setFilterOpen(false)
      }
    }

    const { fromDate, toDate, isDateUpdated } = stateFilter.date
    const tooltipContent = `From ${formatDate(fromDate)} to ${formatDate(toDate)}`

    return (
      <div className='visits-table-header' style={visitsHeaderStyles}>
        {visitsListToShow.map(
          ({
            title,
            align = 'left',
            isFilterActive,
            FilterComponent,
            VisitsFilter,
            filterSvgIcon,
            isShowFilterComponent,
            hasFilter,
          }) => (
            <div
              key={title}
              className={classNames(`visits-table-row--align-${align}`, {
                initialOverflow: isWithFilterColumnTitle(title),
                statusFilter: title === visitTableTitles.STATUS,
                tagFilter: title === visitTableTitles.TAGS,
                'overflow-visible': isFilterOpen,
                'no-left-padding': title === visitTableTitles.TAGS,
              })}>
              {title}
              {hasFilter ?
                <>
                  <Tooltip className='visits-tooltip' content={tooltipContent} disabled={!isDateUpdated}>
                    <span className='visits-filter-icon-container'>
                      <SvgIcon
                        onClick={showFilter}
                        className={classNames('visits-filter-icon', { 'filter-icon-active': isDateUpdated })}
                        name={filterSvgIcon}
                      />
                    </span>
                  </Tooltip>
                  {isFilterOpen && VisitsFilter ?
                    <VisitsFilter
                      stateFilter={stateFilter}
                      dispatchFilter={dispatchFilter}
                      closeFilter={closeFilter}
                      closeRemarks={closeRemarks}
                    />
                  : null}
                </>
              : null}

              {FilterComponent ?
                <>
                  <input
                    type='image'
                    id={`filterImg${title}`}
                    src={isFilterActive ? activeFilterIcon : inactiveFilterIcon}
                    onClick={() => onOpenShowFilterSettings(title)}
                    className='visits-page-table-column-title-filter'
                    alt='filterIcon'
                  />
                  {/*
                   // @ts-expect-error TS2741 -- MIGRATION: not approved, fix when encountered */}
                  <VisitsTableFiltersWrapper
                    visitTypesFilterRow={visitTypesFilterRow}
                    statusFilterRow={statusFilterRow}
                    tagFilterRow={tagFilterRow}
                    closeRemarks={closeRemarks}
                    title={title}
                    tableView={visitsMode}
                    isShowFilterComponent={isShowFilterComponent}
                    FilterComponent={FilterComponent}
                    setVisitTypesFilterRow={setVisitTypesFilterRow}
                    setStatusFilterRow={setStatusFilterRow}
                    setStatusTagRow={setStatusTagRow}
                    setVisitsListToShow={setVisitsListToShow}
                    visitsListToShow={visitsListToShow}
                  />
                </>
              : null}
            </div>
          ),
        )}
      </div>
    )
  },
)
